/* eslint-disable global-require */
import {
	CmsAppFeatureData,
	CmsAppPromoData,
	CmsBannersData,
	CmsDiscoverSalonData,
	CmsDiscoverServiceData,
	CmsHeroData,
	CmsLoginAndRegistrationBannerData,
	CmsNpForBusinessData,
	CmsNpStatisticsData,
	CmsNpTestimonialsData,
	CmsParameterSelectionBannerData,
	CmsReservationDetailData,
	CmsSalonDetailGalleryBannerData,
	CmsSalonListSmallBannerData,
	CmsThankYouPageBannerData
} from '../types/types'
import { getAppContext } from './getAppContext'
import { getIntl } from './intl'

export const HERO_SECTION_FALLBACKS = (): CmsHeroData => {
	const { formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	return {
		title: formatMessage({ id: 'cms-fallbacks-hero-section-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-hero-section-subtitle' }),
		background: {
			desktop: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-desktop.jpg')}`,
			mobile: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-mobile.jpg')}`,
			desktopWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-desktop.webp')}`,
			mobileWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-mobile.webp')}`
		}
	}
}

export const APP_PROMO_FALLBACKS = (): CmsAppPromoData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-app-promo-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-app-promo-subtitle' }),
		background: {
			desktop: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-desktop.jpg')}`,
			mobile: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-mobile.jpg')}`,
			desktopWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-desktop.webp')}`,
			mobileWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-mobile.webp')}`
		},
		tooltip: formatMessage({ id: 'cms-fallbacks-app-promo-tooltip' })
	}

	const commonVideoThumbnailData = {
		alt: formatMessage({ id: 'cms-fallbacks-app-promo-image-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg':
		case 'hu': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-all.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-all.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-all.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-all.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-ro.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-ro.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-sk.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-sk.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-sk.webp`)}`
				},
				video: {
					width: 960,
					height: 600,
					url: 'https://dmrz39codqjlj.cloudfront.net/static/WSK_SK_kristina-banner_960x600.mp4'
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-cs.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-cs.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-cs.webp`)}`
				},
				video: {
					width: 960,
					height: 600,
					url: 'https://dmrz39codqjlj.cloudfront.net/static/WSK_CZ_ewa-banner_960x600.mp4'
				}
			}
		}
	}
}

export const DISCOVER_SALON_FALLBACKS = (): CmsDiscoverSalonData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-discover-salon-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-discover-salon-subtitle' })
	}

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-discover-salon-image-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-bg.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-bg.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hu.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hu.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-ro.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-ro.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-sk.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-sk.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-sk.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-cs.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-cs.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-cs.webp`)}`
				}
			}
		}
	}
}

export const DISCOVER_SERVICE_FALLBACKS = (): CmsDiscoverServiceData => {
	const { formatMessage } = getIntl()

	return {
		title: formatMessage({ id: 'cms-fallbacks-discover-service-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-discover-service-subtitle' })
	}
}

export const APP_FEATURE_FALLBACKS = (): CmsAppFeatureData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-app-feature-title' }),
		subtitle: {
			desktop: formatMessage({ id: 'cms-fallbacks-app-feature-subtitle-desktop' }),
			mobile: formatMessage({ id: 'cms-fallbacks-app-feature-subtitle-mobile' })
		}
	}

	const commonImage1Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-1-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage2Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-2-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage3Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-3-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage4Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-4-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage5Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-5-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.webp`)}`
				}
			}
		}
	}
}

export const TESTIMONIALS_FALLBACKS = (): CmsNpTestimonialsData => {
	const { formatMessage } = getIntl()

	return {
		title: formatMessage({ id: 'cms-fallbacks-testimonials-title' }),
		testimonials: [
			{
				ratingId: 'review-1',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-1-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-1-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-1-text' })
			},
			{
				ratingId: 'review-2',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-2-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-2-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-2-text' })
			},
			{
				ratingId: 'review-3',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-3-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-3-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-3-text' })
			}
		]
	}
}

export const NP_STATISTICS_FALLBACKS = (): CmsNpStatisticsData => {
	const { formatMessage } = getIntl()

	return {
		professionalsCount: formatMessage({ id: 'cms-fallbacks-np-statistics-reservations-count-text-text' }),
		salonsCount: formatMessage({ id: 'cms-fallbacks-np-statistics-salons-count-text' }),
		reservationsCount: formatMessage({ id: 'cms-fallbacks-np-statistics-reservations-count-text' })
	}
}

export const NP_FOR_BUSINESSES_FALLBACKS = (): CmsNpForBusinessData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		backgroundImage: `${assetsPath}/${require('../assets/images/cms-fallbacks/np-for-business/np-for-business-bg.jpg')}`,
		backgroundImageWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/np-for-business/np-for-business-bg.webp')}`
	}

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-nb-for-businesses-image-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-bg.webp`)}`,
					link: 'https://bit.ly/4hUAhVl'
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hu.webp`)}`,
					link: 'https://bit.ly/3QCdr9g'
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-ro.webp`)}`,
					link: 'https://bit.ly/4iaRQ3g'
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-sk.webp`)}`,
					link: 'https://bit.ly/4bjSTLW'
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-cs.webp`)}`,
					link: 'https://bit.ly/43bspdA'
				}
			}
		}
	}
}

export const SALON_LIST_SMALL_BANNER_FALLBACKS = (): CmsSalonListSmallBannerData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-salon-list-small-promo-banner-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-bg.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-bg.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/4i6Ivty'
				}
			}
		}
		case 'hu': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hu.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hu.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/43cTtsZ'
				}
			}
		}
		case 'ro': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-ro.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-ro.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/43gEzC3'
				}
			}
		}
		case 'sk': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-sk.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-sk.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/4hSvfZr'
				}
			}
		}
		case 'cs':
		default: {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-cs.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-cs.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/3EY9oBt'
				}
			}
		}
	}
}

export const LOGIN_AND_REGISTRATION_BANNER_FALLBACKS = (): CmsLoginAndRegistrationBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-login-and-registration-promo-banner-alt' }),
		trackingID: undefined,
		link: undefined
	}

	switch (locale) {
		case 'bg': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-bg.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-bg.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'hu': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-hu.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-hu.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'ro': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-ro.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-ro.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'sk': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-sk.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-sk.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'cs':
		default: {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-cs.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-cs.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
	}
}

export const PARAMETER_SELECTION_BANNER_FALLBACKS = (): CmsParameterSelectionBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-parameter-selection-promo-banner-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-sk.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-cs.webp`)}`
				}
			}
		}
	}
}

export const THANK_YOU_PAGE_BANNER_FALLBACKS = (): CmsThankYouPageBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-thank-you-page-promo-banner-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-bg.webp`)}`,
					link: 'https://www.notino.bg/mobile-application'
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hu.webp`)}`,
					link: 'https://www.notino.hu/mobile-application'
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-ro.webp`)}`,
					link: 'https://www.notino.ro/mobile-application'
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-sk.webp`)}`,
					link: 'https://www.notino.sk/mobile-application'
				}
			}
		}
		case 'cs':
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-cs.webp`)}`,
					link: 'https://www.notino.cz/mobile-application'
				}
			}
		}
	}
}

export const SALON_DETAIL_GALLERY_BANNER_FALLBACKS = (): CmsSalonDetailGalleryBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		mobileWebP: undefined,
		alt: formatMessage({ id: 'cms-fallbacks-salon-detail-gallery-promo-banner-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-mobile-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-mobile-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-mobile-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-mobile-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-sk.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-mobile-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-detail-gallery-banner/salon-detail-gallery-banner-desktop-cs.webp`)}`
				}
			}
		}
	}
}

// NOTE: only desktop version of the banner exists
export const RESERVATION_DETAIL_BANNER_FALLBACKS = (): CmsReservationDetailData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-reservation-detail-promo-banner-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-sk.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-cs.webp`)}`
				}
			}
		}
	}
}

export const BANNERS_FALLBACKS = (): CmsBannersData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonBannerData = {
		id: 'fallback-banner',
		backgroundImage: `${assetsPath}/${require('../assets/images/cms-fallbacks/banners/banner-1-background.jpg')}`
	}

	const commonImageData = {
		desktopWebP: undefined,
		mobileWebP: undefined,
		alt: formatMessage({ id: 'cms-fallbacks-banner-1-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				banners: [
					{
						...commonBannerData,

						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-bg-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-bg-mobile.jpg`)}`,
							link: 'https://www.notino.bg/salons-promo/'
						}
					}
				]
			}
		}
		case 'hu': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-hu-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-hu-mobile.jpg`)}`,
							link: 'https://www.notino.hu/salons-promo/'
						}
					}
				]
			}
		}
		case 'ro': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-ro-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-ro-mobile.jpg`)}`,
							link: 'https://www.notino.ro/salons-promo/'
						}
					}
				]
			}
		}
		case 'sk': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-sk-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-sk-mobile.jpg`)}`,
							link: 'https://www.notino.sk/salons-promo/'
						}
					}
				]
			}
		}
		case 'cs':
		default: {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-cs-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-cs-mobile.jpg`)}`,
							link: 'https://www.notino.cz/salons-promo/'
						}
					}
				]
			}
		}
	}
}
